import {Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../environments/environment";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    
    intercept(req: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> {
        if(req.url.startsWith('/api')){
            const url = environment.baseUrl;
            req = req.clone({
                url: url + req.url,
            });
            return next.handle(req);
        } else {
            return next.handle(req);
        }
    }

}
        
        